export default {
  methods: {
    formatNumber(num) {
      const sign = Math.sign(num)
      const absNum = Math.abs(num)

      let formatted = ''

      if (absNum >= 1000000000) {
        formatted = (absNum / 1000000000).toFixed(2) + 'B'
      } else if (absNum >= 1000000) {
        formatted = (absNum / 1000000).toFixed(2) + 'M'
      } else if (absNum >= 1000) {
        formatted = (absNum / 1000).toFixed(2) + 'K'
      } else {
        formatted = absNum.toFixed(2)
      }
      return ((sign < 0 ? '-' : '') + formatted)?.replace('.00', '')
    }
  }
}
